module.exports = __webpack_public_path__ + "static/media/il.f62b32f0.svg";